export default "__VITE_ASSET__CEjCgfQF__"